import React, { Component } from 'react';
import { Card, Flex, WhiteSpace, Button, Modal, Toast, List, InputItem, WingBlank, Picker, ActionSheet } from 'antd-mobile';
import promptModal from '../components/PromptModal';
import CustomButton from '../components/Button';
import iconAvatar from '../medias/avatar.svg';
import iconWidthdraw from '../medias/withdraw.svg';
import iconWidthdraw2 from '../medias/withdraw2.svg';
import iconDelegate from '../medias/delegate.svg';
import iconSwitch from '../medias/switch.svg';
import iconAccount from '../medias/account.svg';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import StorageUtils from '../utils/StorageUtils';
import { createForm } from 'rc-form';
import '../styles/AgentMine.css';


const history = require("history").createHashHistory()

class AgentMine extends Component {
    constructor(props){
        super(props);
        this.state = {
            agentProfile: {
                agentName: null,
                mobile: null,
                realName: null,
                nickName: '会员',
                avatar: null,
                profitPoint: 0,
                balance: 0,
                bankNo: null,
                bankTrueName: null,
                bankCode: null,
                maxSites: 0,
                maxMembers: 0
            },
            bankList: [],
            delegateAccounts: [],
            showUpdateBankModal: false,
            enableUpdateBank: true,
            showUpdateAutoWithdrawModal: false,
            enableUpdateAutoWithdraw: true
        }
    }

    componentDidMount() {
        this.loadBanks(() => {
            this.loadProfile();
        });
        this.loadDelegateAccounts();
    }

    loadProfile = () => {
        DataFetcher.agentProfile({
            success: (resp) => {
                this.setState({
                    agentProfile: resp.data
                })
            }
        })
    }

    loadDelegateAccounts = () => {
        DataFetcher.delegateAccounts({
            success: (resp) => {
                this.setState({
                    delegateAccounts: resp.data
                })
            }
        })
    }

    loadBanks = (callback) => {
        DataFetcher.bankList({
            success: (resp) => {
                this.setState({
                    bankList: resp.data
                }, () => {
                    callback&&callback()
                })
            }
        })
    }

    resolveBankName = (bankCode) => {
        const { bankList } = this.state
        for(let bank of bankList) {
            if(bank.code === bankCode) {
                return bank.name
            }
        }
        return bankCode
    }

    maskBankNo = (bankNo) => {
        if(CommonUtils.isEmpty(bankNo)) return ''

        if(bankNo.length < 8) {
            return bankNo
        }
        
        return bankNo.substr(0, 4) + '***' + bankNo.substr(-4, 4)
    }

    handleBillClick = () =>  (
        history.push('/agent/bill')
    )

    handleWithdrawHistoryClick = () =>  (
        history.push('/withdraw')
    )

    handleDelegateClick = () =>  (
        history.push('/agent/delegate')
    )

    handleSwitchClick = () => {
        const { delegateAccounts } = this.state
        let buttons = delegateAccounts.map(item => `${item.delegateName}（${item.agentName}）`)
        ActionSheet.showActionSheetWithOptions({
          options: buttons,
          title: '切换帐号',
          maskClosable: true,
        },
        (buttonIndex) => {
            if(!delegateAccounts[buttonIndex]) return
            StorageUtils.storeStringToSession(Constants.Storage.DELEGATE_SELECTED_TAB, 'homeTab')
            history.push(`/delegate/home/${delegateAccounts[buttonIndex].id}`)
        });
    }

    handleWithdrawApplyClick = () => {
        const { agentProfile } = this.state;
        if(CommonUtils.isEmpty(agentProfile.bankTrueName)
        ||CommonUtils.isEmpty(agentProfile.bankNo)
        ||CommonUtils.isEmpty(agentProfile.bankCode)) {
            Toast.info('请先完善提现信息', 2)
            return;
        }

        promptModal(
            '提现申请', 
            '24小时内到账',
            [
                { text: '取消' },
                {
                    text: '确定',
                    onPress: number => new Promise((resolve) => {
                        DataFetcher.agentWithdraw({
                            amount: number
                        }, {
                            success: () => {
                                Toast.info('提现申请提交成功', 2);
                                this.loadProfile();
                            },
                            completed: () => {
                                resolve();
                            }
                        })
                    })
                },
            ], 
            'number', 
            null, 
            ['请输入提现金额']
        )
    }

    handleUpdateBankClick = () => {
        this.setState({
            enableUpdateBank: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('bank_') !== 0) {
                        continue
                    }
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdateBank: true
                        })
                        return
                    }
                }
            }

            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('bank_') !== 0) {
                    continue
                }
                params[prop.substring('bank_'.length)] = fieldsValue[prop]                
            }
            params.bankCode = params.bankCode[0]
            DataFetcher.updateBank(params, {
                success: (resp) => {
                    this.setState({
                        showUpdateBankModal: false
                    })
                    Toast.info('修改成功')
                    this.props.form.resetFields()
                    this.loadProfile()
                },
                completed: () => {
                    this.setState({
                        enableUpdateBank: true
                    })
                }
            })
        });
    }

    handleUpdateAutoWithdrawClick = () => {
        this.setState({
            enableUpdateAutoWithdraw: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                debugger
                for(let prop in error) {
                    if(prop.indexOf('auto_') !== 0) {
                        continue
                    }
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdateAutoWithdraw: true
                        })
                        return
                    }
                }
            }

            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('auto_') !== 0) {
                    continue
                }
                params[prop.substring('auto_'.length)] = fieldsValue[prop]                
            }
            params.autoWithdraw = params.autoWithdraw[0]
            DataFetcher.updateAutoWithdraw(params, {
                success: (resp) => {
                    this.setState({
                        showUpdateAutoWithdrawModal: false
                    })
                    Toast.info('修改成功')
                    this.props.form.resetFields()
                    this.loadProfile()
                },
                completed: () => {
                    this.setState({
                        enableUpdateAutoWithdraw: true
                    })
                }
            })
        });
    }

    handleUpdateProfile = () => {
        const { agentProfile } = this.state

        promptModal(
            '个人信息', 
            null,
            [
                { text: '取消' },
                {
                    text: '确定',
                    onPress: (fieldsValue) => new Promise((resolve) => {
                        DataFetcher.updateAgentProfile({
                            mobile: fieldsValue
                        }, {
                            success: () => {
                                this.loadProfile();
                                resolve();
                            }
                        });
                    })
                }
            ], 
            'plain-text', 
            [agentProfile.mobile], 
            ['手机号']
        )
    }

    doRenderUpdateBankModal = () => {
        const { getFieldProps } = this.props.form;
        const { agentProfile, showUpdateBankModal, enableUpdateBank, bankList } = this.state
        const bankPickerData = bankList.map(item => ({label: item.name, value: item.code}))

        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateBankModal}
                    onClose={() => {
                        this.setState({showUpdateBankModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>手动提现</div>}>
                        <InputItem {...getFieldProps('bank_bankTrueName', {
                            initialValue: agentProfile.bankTrueName,
                            rules: [{required: true, message: '请填写开户人'}],
                        })}>
                            开&nbsp;&nbsp;户&nbsp;&nbsp;人
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={bankPickerData}
                            {...getFieldProps('bank_bankCode', {
                                initialValue: [agentProfile.bankCode],
                                rules: [{required: true, message: '请选择开户行'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">开&nbsp;&nbsp;户&nbsp;&nbsp;行</List.Item>
                        </Picker>
                        <InputItem type='number' {...getFieldProps('bank_bankNo', {
                            initialValue: agentProfile.bankNo,
                            rules: [{required: true, message: '请填写银行卡号'}],
                        })}>
                            银行卡号
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateBankClick} disabled={!enableUpdateBank}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateAutoWithdrawModal = () => {
        const { getFieldProps } = this.props.form;
        const { agentProfile, showUpdateAutoWithdrawModal, enableUpdateAutoWithdraw } = this.state
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateAutoWithdrawModal}
                    onClose={() => {
                        this.setState({showUpdateAutoWithdrawModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>自动提现</div>}>
                        <Picker 
                            cols={1}
                            data={[{label:'否', value: 0}, {label: '是', value: 1}]}
                            {...getFieldProps('auto_autoWithdraw', {
                                initialValue: [agentProfile.autoWithdraw],
                                rules: [{required: true, message: '请选择是否启用'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">是否启用</List.Item>
                        </Picker>
                        <InputItem {...getFieldProps('auto_qflMerchantId', {
                            initialValue: agentProfile.qflMerchantId,
                            rules: [{required: true, message: '请填写商户号'}],
                        })}>
                            商&nbsp;&nbsp;户&nbsp;&nbsp;号
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateAutoWithdrawClick} disabled={!enableUpdateAutoWithdraw}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    render() {
        const { agentProfile, delegateAccounts } = this.state;
        return (
            <div className='page-agent-mine'>
                <Card full>
                    <Card.Header
                        title={
                            <div className='wrapper-main'>
                                <div className='name word-ellipsis'>{agentProfile.nickName}</div>
                                <div className='mobile word-ellipsis'>{agentProfile.mobile}</div>
                            </div>}
                        thumb={<img src={CommonUtils.isEmpty(agentProfile.avatar)?iconAvatar:agentProfile.avatar} alt="avatar"/>}
                        extra={<CustomButton onClick={this.handleUpdateProfile} className="md icon-setting" style={{float: 'right'}}/>}
                    />
                    <Card.Body>
                        <div className='wrapper-info'>
                            <div className="subtitle">
                                <span className='text'>账户信息</span>
                            </div>
                            <WhiteSpace size="sm"/>
                            <Flex>
                                <Flex.Item>
                                    <span className="label">账户余额：</span>
                                    <span className="price-symbol">￥</span>
                                    <span className="value price">{agentProfile.balance}</span>
                                </Flex.Item>
                                <Flex.Item>
                                    <span className="label">分成比例：</span>
                                    <span className="value">{agentProfile.profitPoint}%</span>
                                </Flex.Item>
                            </Flex>
                            <WhiteSpace size="sm"/>
                            <Flex>
                                <Flex.Item>
                                    <span className="label">门店上限：</span>
                                    <span className="value">{agentProfile.maxSites}</span>
                                </Flex.Item>
                                {agentProfile.parentAgentId?(
                                    <Flex.Item>
                                        <span className="label">上级代理：</span>
                                        <span className="value">{agentProfile.parentAgentName}</span>
                                    </Flex.Item>
                                ):(
                                    <Flex.Item>
                                        <span className="label">团队上限：</span>
                                        <span className="value">{agentProfile.maxMembers}</span>
                                    </Flex.Item>
                                )}
                            </Flex>
                            <WhiteSpace size="lg"/>
                            <WhiteSpace size="sm"/>
                            <div className="subtitle">
                                <span className='text'>手动提现</span>
                                <span className='tip'>(手动发起提现，提现到银行卡)</span>
                                <span className='action' onClick={() => {this.setState({showUpdateBankModal: true})}}>
                                    <i className='iconfont icon-xiugai'/>
                                </span>
                            </div>
                            <WhiteSpace size="sm"/>
                            <Flex>
                                <Flex.Item className="word-ellipsis">
                                    <span className="label">开&nbsp;&nbsp;户&nbsp;&nbsp;人：</span>
                                    <span className="value">{agentProfile.bankTrueName}</span>
                                </Flex.Item>
                                <Flex.Item className="word-ellipsis">
                                    <span className="label">开&nbsp;&nbsp;户&nbsp;&nbsp;行：</span>
                                    <span className="value">{this.resolveBankName(agentProfile.bankCode)}</span>
                                </Flex.Item>
                            </Flex>
                            <WhiteSpace size="sm"/>
                            <Flex>
                                <Flex.Item className="word-ellipsis">
                                    <span className="label">银行卡号：</span>
                                    <span className="value">{this.maskBankNo(agentProfile.bankNo)}</span>
                                </Flex.Item>
                            </Flex>
                            <WhiteSpace size="lg"/>
                            <WhiteSpace size="sm"/>
                            <div className="subtitle">
                                <span className='text'>自动提现</span>
                                <span className='tip'>(T+1自动到账，需联系客服申请商户号)</span>
                                <span className='action' onClick={() => {this.setState({showUpdateAutoWithdrawModal: true})}}>
                                    <i className='iconfont icon-xiugai'/>
                                </span>
                            </div>
                            <WhiteSpace size="sm"/>
                            <Flex>
                                <Flex.Item className="word-ellipsis">
                                    <span className="label">是否启用：</span>
                                    <span className="value">{agentProfile.autoWithdraw===1?'是':'否'}</span>
                                </Flex.Item>
                                <Flex.Item className="word-ellipsis">
                                    <span className="label">商&nbsp;&nbsp;户&nbsp;&nbsp;号：</span>
                                    <span className="value">{agentProfile.qflMerchantId}</span>
                                </Flex.Item>
                            </Flex>
                        </div>
                    </Card.Body>
                </Card>
                <WhiteSpace/>
                <div onClick={this.handleBillClick}>
                    <Button icon={<img src={iconAccount} alt="bill"/>} style={{color: '#444'}}> 账户明细</Button>
                </div>
                <WhiteSpace/>
                <div onClick={this.handleWithdrawApplyClick}>
                    <Button icon={<img src={iconWidthdraw} alt="withdraw"/>} style={{color: '#444'}}> 提现申请</Button>
                </div>
                <WhiteSpace/>
                <div onClick={this.handleWithdrawHistoryClick}>
                    <Button icon={<img src={iconWidthdraw2} alt="history"/>} style={{color: '#444'}}> 提现记录</Button>
                </div>
                <WhiteSpace/>
                <div onClick={this.handleDelegateClick}>
                    <Button icon={<img src={iconDelegate} alt="delegate"/>} style={{color: '#444'}}> 帐号授权</Button>
                </div>
                <WhiteSpace/>
                {delegateAccounts&&delegateAccounts.length?(
                    <div onClick={this.handleSwitchClick}>
                        <Button icon={<img src={iconSwitch} alt="switch"/>} style={{color: '#444'}}> 切换帐号</Button>
                    </div>
                ):(<div></div>)}
                <WhiteSpace/>
                {this.doRenderUpdateBankModal()}
                {this.doRenderUpdateAutoWithdrawModal()}
            </div>
        )
    }
}

export default createForm()(AgentMine);


// WEBPACK FOOTER //
// ./src/modules/AgentMine.js